import {
  noticeTypeForDuplicate,
  restoreNoticeForm,
  type NoticeRestoreSource,
  type NoticeRestorePayload,
} from "../domain/notices/noticePayload";
import type { DraftRestorePayload } from "./draftRestore";

export type NoticeDuplicateSource = NoticeRestoreSource;

export type NoticeDuplicatePayload = NoticeRestorePayload & {
  initialFormData: DraftRestorePayload["initialFormData"] & {
    eventReminderMode?: string;
    eventReminderModes?: string[];
    targetUserId?: string;
  };
};

export { noticeTypeForDuplicate };

/**
 * Prefill Create from an existing notice.
 * Event dates are cleared so the user must pick the next occurrence;
 * time, location, reminders, audience, and attachments are kept.
 */
export const buildNoticeDuplicatePayload = (
  notice: NoticeDuplicateSource,
): NoticeDuplicatePayload => restoreNoticeForm(notice, "duplicate");
